import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { mappingCandidatesListQueryOptions } from '~/features/admin-mapping-candidates/query-options'
import { MappingWorkbenchPage } from '~/features/admin/mapping-workbench'
import { liveOddsCandidatesQueryOptions, liveOddsReadinessQueryOptions } from '~/features/live-odds-admin/query-options'
import { mappingCoverageSignalsQueryOptions } from '~/features/mapping-coverage/query-options'
import { readinessQueryOptions } from '~/features/sports-verifier/query-options'

const mappingsSearchSchema = z.object({
  status: z.enum(['pending', 'dismissed', 'approved']).optional().default('pending'),
  page: z.coerce.number().optional().default(1),
  minScore: z.coerce.number().optional(),
  eventId: z.string().optional(),
  competitionCode: z.string().trim().min(1).optional().default('demo_world_cup'),
  season: z.coerce.number().int().positive().optional().default(2026),
})

export const Route = createFileRoute('/admin/mappings')({
  validateSearch: mappingsSearchSchema,
  loaderDeps: ({ search: { status, page, minScore, competitionCode, season } }) => ({ status, page, minScore, competitionCode, season }),
  loader: async ({ context, deps: { status, page, minScore, competitionCode, season } }) => {
    const scope = { competitionCode, season }
    await Promise.all([
      context.queryClient.prefetchQuery(liveOddsReadinessQueryOptions(scope)),
      context.queryClient.prefetchQuery(liveOddsCandidatesQueryOptions(scope)),
      context.queryClient.prefetchQuery(mappingCoverageSignalsQueryOptions({ limit: 50, ...scope })),
      context.queryClient.prefetchQuery(readinessQueryOptions()),
      context.queryClient.prefetchQuery(
        mappingCandidatesListQueryOptions({
          status,
          page,
          pageSize: 20,
          minScore: minScore !== undefined ? minScore * 100 : undefined,
          ...scope,
        }),
      ),
    ])
  },
  component: MappingWorkbenchPage,
})
